export const isRobotNoFollow = (value: string): boolean => value?.toLowerCase() === "nofollow";
export const isRobotNoIndex = (value: string): boolean => value?.toLowerCase() === "noindex";

/** `</script>` in review or CMS text would break out of the tag; `\u003c` parses back to `<`. */
export const serializeJsonLd = (value: unknown): string =>
    JSON.stringify(value).replace(/</g, "\\u003c");
